export default {
  app_title: "Kraftstoffpreise",
  fuel_label: "Kraftstoff",
  fuel_95: "Benzin 95",
  fuel_98: "Benzin 98",
  fuel_diesel: "Diesel",
  region_label: "Region",
  region_all: "Ganz Spanien",
  list_header: "Günstigster Kraftstoff in der Nähe",
  list_show_all: "Alle anzeigen",
  list_empty: "Keine Tankstellen in diesem Gebiet",
  list_expand: "Liste ausklappen",
  list_collapse: "Liste einklappen",
  card_navigate: "Maps",
  locate_me: "Standort",
  no_location_permission: "Standortzugriff verweigert",
  loading: "Lädt...",
  error_loading: "Fehler beim Laden",
  attribution: "© OpenStreetMap, CartoDB",
  expand_map: "Karte vergrößern",
  collapse_map: "Karte verkleinern",
  station_count: "Tankstellen",
  gesture_hint: "Zwei Finger zum Verschieben der Karte",
};
